export default [
  {
    name: 'O. Fiscales',
    icon: 'mdi-alert-octagon',
    path: '/admin/fiscal-obligations',
    component: () =>
      import(/* webpackChunkName: "admin-fiscal-obligations" */ './views/FiscalObligations'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
